import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=30faf328&scoped=true&"
import script from "./Announcements.vue?vue&type=script&lang=ts&"
export * from "./Announcements.vue?vue&type=script&lang=ts&"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=30faf328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30faf328",
  null
  
)

export default component.exports